import "./App.css";
import Main from "./components/Main";

const App = () => {
  return (
    <div className="App">
      <Main />
    </div>
  );
};

export default App;
